/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { DelphinusCardFragment } from "@cosmos/hygraph-schema";

import { css, cx } from "@panda/css";
import { Grid } from "@panda/jsx";
import { SystemStyleObject } from "@panda/types";

import { DelphinusCard } from "./DelphinusCard.molecule";

const Layout_grid: SystemStyleObject = {
	gridTemplateColumns: "repeat(3, 1fr)",
	lgDown: { gridTemplateColumns: "repeat(2, 1fr)" },
	mdDown: { gridTemplateColumns: "repeat(1, 1fr)!" },
};

export type DelphinusCardsProps = {
	grid: DelphinusCardFragment[];
};

export function DelphinusCardsGrid({ grid }: DelphinusCardsProps): React.JSX.Element {
	return (
		<Grid className={cx("delphinus-cards", css(Layout_grid))} gap="eds.dimension.16">
			{grid.map((card, i) => (
				<DelphinusCard key={`delphinus-card-${i}`} {...card} />
			))}
		</Grid>
	);
}
